import {
    IEquityMovementScheduleData,
    IPdfTronData,
    ISignatureData,
    NotesItemsTypes,
} from '@modeso/aumico-lib-annualreport-fe';
import { DateLocalePipe, EMPTY_STRING } from '@modeso/aumico-lib-core-fe';
import { IDynamicKeyValue } from '@modeso/types__aumico-lib-core-be';

export class PlaceholderReplacerVisitor {
    constructor(private readonly placeholderMap: IDynamicKeyValue, private readonly dateLocalePipe: DateLocalePipe) { }

    visit(pdftronData: IPdfTronData): void {
        if (pdftronData.crs != null) {
            pdftronData.crs.forEach((value) => {
                const updatedData = this.replace(
                    value.data as string,
                    pdftronData.currency,
                    pdftronData.organization.country,
                    pdftronData.signatures,
                );
                value.data = updatedData;
            });
        }

        if (pdftronData.crsA01 != null) {
            pdftronData.crsA01.forEach((value) => {
                const updatedData = this.replace(
                    value.data as string,
                    pdftronData.currency,
                    pdftronData.organization.country,
                    pdftronData.signatures,
                );
                value.data = updatedData;
            });
        }

        if (pdftronData.crsA02 != null) {
            pdftronData.crsA02.forEach((value) => {
                const updatedData = this.replace(
                    value.data as string,
                    pdftronData.currency,
                    pdftronData.organization.country,
                    pdftronData.signatures,
                );
                value.data = updatedData;
            });
        }

        if (pdftronData.crsA03 != null) {
            pdftronData.crsA03.forEach((value) => {
                const updatedData = this.replace(
                    value.data as string,
                    pdftronData.currency,
                    pdftronData.organization.country,
                    pdftronData.signatures,
                );
                value.data = updatedData;
            });
        }

        if (pdftronData.nts != null) {
            pdftronData.nts.subsections.forEach((note) => {
                note.items.forEach((item) => {
                    if (item.itemType === NotesItemsTypes.RICH_TEXT) {
                        const updatedData = this.replace(
                            item.data as string,
                            pdftronData.currency,
                            pdftronData.organization.country,
                            pdftronData.signatures,
                        );
                        item.data = updatedData;
                    }
                });
            });
        }

        if (pdftronData.ems != null) {
            const emsData = pdftronData.ems.data as IEquityMovementScheduleData;
            emsData.textAdditionAboveEms = emsData.textAdditionAboveEms
                ? this.replace(
                    emsData.textAdditionAboveEms,
                    pdftronData.currency,
                    pdftronData.organization.country,
                    pdftronData.signatures,
                )
                : EMPTY_STRING;
            emsData.textAdditionBelowEms = emsData.textAdditionBelowEms
                ? this.replace(
                    emsData.textAdditionBelowEms,
                    pdftronData.currency,
                    pdftronData.organization.country,
                    pdftronData.signatures,
                )
                : EMPTY_STRING;
        }

        if (pdftronData.aop != null) {
            const { description, ccrFootnote } = pdftronData.aop;
            pdftronData.aop.description = description
                ? this.replace(
                    description,
                    pdftronData.currency,
                    pdftronData.organization.country,
                    pdftronData.signatures,
                )
                : EMPTY_STRING;
            if (ccrFootnote) {
                pdftronData.aop.ccrFootnote = this.replace(
                    ccrFootnote,
                    pdftronData.currency,
                    pdftronData.organization.country,
                    pdftronData.signatures,
                );
            }
        }
    }

    private replace(value: string, currency: string, organizationCountry: string, signatures: ISignatureData): string {
        const updatedData = value.replace(
            /<span[^>]*data-mention="([^"]+)"[^>]*>.*?<\/span>/g,
            (match, mentionTagName) => {
                if (!mentionTagName) {
                    return match;
                }

                switch (mentionTagName) {
                    case '@ar.currency':
                        return currency != null ? currency : '';
                    case '@org.country':
                        return organizationCountry != null ? organizationCountry : '';
                    case '@ar.signatory1':
                        return signatures.signature1 != null ? signatures.signature1 : '';
                    case '@ar.signatory2':
                        return signatures.signature2 != null ? signatures.signature2 : '';
                    case '@ar.place-of-signing':
                        return signatures.place != null ? signatures.place : '';
                    case '@ar.date-of-signing':
                        return signatures.date != null ? signatures.date : '';
                }

                const placeholder = this.placeholderMap[mentionTagName];

                if (placeholder != null) {
                    return placeholder;
                } else {
                    return match;
                }
            },
        );

        return updatedData;
    }
}
